import React from 'react';
import PropTypes from 'prop-types';
import CategoriesTable from 'components/shared/CategoriesTable';
import { Button } from 'components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'components/ui/dialog';

const CategoriesModal = ({ isOpened = false, isPilgrimUser = false, categories = null, closeModal = () => {} }) => {
  return (
    <Dialog open={isOpened} onOpenChange={closeModal}>
      <DialogContent className="flex max-h-[calc(100dvh-1rem)] w-[calc(100%-1rem)] max-w-[1024px] flex-col gap-0 overflow-hidden rounded-[14px] border-gray-200 bg-white p-0 font-sans shadow-2xl sm:max-h-[calc(100dvh-3rem)]">
        <DialogHeader className="shrink-0 space-y-1 border-b border-gray-200 px-4 py-4 pr-14 text-left sm:px-6 sm:py-5">
          <DialogTitle className="text-lg font-semibold text-gray-900">Détails des catégories</DialogTitle>
          <DialogDescription className="text-[13px] text-gray-500">
            Comparez les prestations et conditions des catégories disponibles.
          </DialogDescription>
        </DialogHeader>

        <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain">
          <CategoriesTable categories={categories} isPilgrimUser={isPilgrimUser} variant="comparison" />
        </div>

        <DialogFooter className="shrink-0 flex-row justify-end border-t border-gray-200 px-4 py-3 sm:px-6">
          <Button variant="outline" className="border-[#d7ded9]" onClick={closeModal}>
            Fermer
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

CategoriesModal.propTypes = {
  isOpened: PropTypes.bool,
  isPilgrimUser: PropTypes.bool,
  categories: PropTypes.arrayOf(PropTypes.shape({})),
  closeModal: PropTypes.func,
};

export default CategoriesModal;
